<template>
    <div class="table-layout">
        <div class="input-tip error">提示:跨机构调拨时,资产如果在套装中,将解除关联套装,如果资产是套装主资产则套装将解散。</div>

        <div class="right-toolbar mb5 fr">
            <span>已选择({{(transVoucherInfo.itemList || []).length}})</span>
        </div>
        <el-form :model="transVoucherInfo" ref="deviceItem">
            <virtual-scroll ref="virtTable"
                            :data="transVoucherInfo.itemList"
                            key-prop="deviceXId"
                            @change="(virtualList) => virtItems = virtualList"
                            @selection-change="handleSelectionChange">
                <el-table ref="multipleTable" :data="virtItems" border maxHeight="500" tooltip-effect="dark">
                    <virtual-column label="索引" width="60" fixed="left" type="index"></virtual-column>
                    <el-table-column align="left" prop="innerCode" label="资产编号" fixed="left" width="150">
                        <template slot-scope="rows">
                            <a class="table-cell-link" @click="viewAssetInfo(rows.row);">{{rows.row.innerCode}}</a>
                        </template>
                    </el-table-column>
                    <el-table-column prop="innerNo" label="外部资产编码" width="180" align="left"></el-table-column>
                    <el-table-column prop="assetType" width="100" label="管理方式" align="center" fixed="left">
                        <template slot-scope="rows">
                            <span>{{assetTypeMap[rows.row.assetType]}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="left" prop="title" width="200" label="资产描述全称"></el-table-column>
                    <el-table-column align="left" prop="fixedSpec" width="180" label="规格"></el-table-column>
                    <el-table-column align="center" prop="reserved" width="80" label="预定情况" v-if="transVoucherInfo.reserveFlag">
                        <template slot-scope="rows">
                            <span>{{ rows.row.reserved ? '已被预定' : '可以预定' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="transQuantity" label="调拨数量" width="80" align="right"></el-table-column>
                    <el-table-column label="控制方式" align="center" width="80">
                        <template slot-scope="scope">
                            <span>{{scope.row.splitible ? '按金额' : '按数量'}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="整批调拨" align="center" width="80">
                        <template slot-scope="scope">
                            <input type="checkbox" :disabled="scope.row.assetType == commonDevcVal" v-model="scope.row.transAll" @change="splitFlagChange(scope.$index)"/>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" prop="quantity" label="本次调拨数量" width="100">
                        <template slot-scope="scope">
                            <span v-if="scope.row.assetType == commonDevcVal">{{scope.row.quantity}}</span>
                            <el-form-item :prop="'itemList.' + scope.$index + '.quantity'" :rules="{validator: inputTransAvQuantity, trigger: 'blur'}" v-else>
                                <el-input :disabled="disabledQuantity(scope.row.splitible, scope.row.splitFlag) || srcCheck" type="number" min="1" class="input-content-right" @change="transAvQuantityChange(scope);"
                                          v-model.number="scope.row.quantity"></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" prop="theUnit" label="单位" width="60"></el-table-column>
                    <el-table-column align="right" prop="splittedAmount" width="100" label="调拨原值(元)">
                        <template slot-scope="rows">
                            <span v-if="rows.row.assetType == commonDevcVal">{{rows.row.orgWorth}}</span>
                            <el-form-item :prop="'itemList.' + rows.$index + '.splittedAmount'" :rules="{validator: inputSplittedAmount, trigger: 'blur'}" v-else>
                                <input style="width:90%" :disabled="!rows.row.splitible || !rows.row.splitFlag || srcCheck" type="number" min="0" class="input-content-right" @change="splittedAmountChange(rows);" v-model.number="rows.row.splittedAmount"/>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" prop="orgWorth" width="80" label="资产原值(元)">
                        <template slot-scope="rows">
                            <span v-if="rows.row.assetOrgWorth != null">{{rows.row.assetOrgWorth.toFixed(2)}}</span>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column align="right" prop="netWorth" width="80" label="调入原值(元)">
                         <template slot-scope="rows">
                             <span v-if="rows.row.orgWorth != null">{{rows.row.orgWorth.toFixed(2)}}</span>
                         </template>
                     </el-table-column>
                     <el-table-column align="right" prop="netWorth" width="80" label="调入净值(元)">
                         <template slot-scope="rows">
                             <span v-if="rows.row.netWorth != null">{{rows.row.netWorth.toFixed(2)}}</span>
                         </template>
                     </el-table-column>
                     <el-table-column align="right" prop="aggtDeprWorth" width="80" label="调入累计折旧(元)">
                         <template slot-scope="rows">
                             <span v-if="rows.row.aggtDeprWorth != null">{{rows.row.aggtDeprWorth.toFixed(2)}}</span>
                         </template>
                     </el-table-column>-->
                    <el-table-column prop="" label="调入机构" width="300">
                        <template slot-scope="scope">
                            <span v-if="scope.row.dstMerchantId != scope.row.retailerId && scope.row.dstMerchantName != null">{{scope.row.dstMerchantName}}</span>
                            <span v-if="scope.row.dstMerchantId != scope.row.retailerId && scope.row.dstMerchantName != null && scope.row.dstComFullName != null">/</span>
                            <span>{{scope.row.dstComFullName || ''}}</span>
                            <!--<span v-if="scope.row.dstBizUnitName != null">{{scope.row.dstBizUnitName}}</span>-->
                            <!--<span v-if="scope.row.dstBizUnitName != null && scope.row.dstComName != null && scope.row.dstBizUnitName != scope.row.dstComName">/{{scope.row.dstComName}}</span>-->
                            <a v-if="!taxRateChange && id == null" class="swb-btn-link" align="right" @click="selectDstBizUnitName(scope.$index)">选择机构</a>
                        </template>
                    </el-table-column>
                    <el-table-column prop="dstComNo" label="调入机构编号" width="120"></el-table-column>
                    <el-table-column prop="dstCostCenterCode" label="调入成本中心" width="160"></el-table-column>
                    <el-table-column prop="srcComFullName" label="调出部门全称" width="140" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="srcRealComCode" label="调出公司编码" width="160"></el-table-column>
                    <el-table-column prop="srcCostCenterCode" label="调出成本中心" width="160"></el-table-column>
                    <el-table-column prop="taxRate" label="税率(%)" align="right" width="100" v-if="srcNormalFlag">
                        <template slot-scope="scope">
                            <span v-if="!taxRateChange">{{scope.row.taxRate}}</span>
                            <el-select v-else-if="taxRateChange" v-model="scope.row.taxRate" placeholder="请选择税率" @change="rateChange" :disabled="srcCheck">
                                <el-option v-for="item in fiscalTaxMarkList" :key="item.rate" :label="item.rate" :value="item.rate"></el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column prop="deprMonth" label="入账时间" width="150" align="right">
                        <template slot-scope="rows">
                            <span v-if="rows.row.fiscalInTime != null">{{rows.row.fiscalInTime}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="left" prop="memo" label="备注" width="100" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-input :disabled="taxRateChange" v-model="scope.row.memo" type="textarea" @change="memoChange"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column align="left" prop="tmpNo" width="250" label="系统编号" show-overflow-tooltip></el-table-column>
                    <el-table-column align="right" prop="quantity2" label="含报废数量" width="120"></el-table-column>
                    <el-table-column prop="devcCustTag1Val" :label="devcCustTag1.dispName" width="120" v-if="devcCustTag1.enabled == true" >
                    </el-table-column>
                    <el-table-column prop="devcCustTag2Val" :label="devcCustTag2.dispName" width="120" v-if="devcCustTag2.enabled == true">
                    </el-table-column>
                    <el-table-column prop="devcCustTag3Val" :label="devcCustTag3.dispName" width="120" v-if="devcCustTag3.enabled == true">
                    </el-table-column>
                    <el-table-column label="操作" fixed="right">
                        <template slot-scope="scope">
                            <a v-if="!taxRateChange && !srcCheck" class="swb-btn-link" @click="removeDeviceItem(scope.$index)">移除</a>
                        </template>
                    </el-table-column>
                </el-table>
            </virtual-scroll>
        </el-form>

    </div>
</template>
<script>
    import {Utils} from '../../app.base'
    import {Vue, MsgBox, Routes, VirtualScroll, VirtualColumn} from '../../app.vues'
    import {openRetailComTreeSelectDlg, openRetailerListForSelectDlg} from '../retailer/selectDlg';
    import {getMerchantBizParam} from '../asset/assetMain'
    import {assetFiscalInfoDlg} from '../retailer/dialog'
    import {getDefaultPageSizes} from '../../../src/app.conf'

    import assetVchrApi from '../../api/assetVchr'
    import shopStockApi from '../../api/shopStock'
    import userApi from '../../api/user'
    import fiscalBizApi from '../../api/fiscalBiz'
    import retailerApi from '../../api/retailer'
    import custTagMeataApi from '../../api/objTagConf'

    export default {
        name: 'swb-shop-device-trans-voucher-item-scroll',
        avlActions: '',
        notAsResc: true,
        authen: false,
        desc: '资产调拨单项',
        props: ['srcComId', 'id', 'suitFlag', 'offline', 'transItemList', 'taxRateChange', "reloadItemInfo", 'srcCheck'],
        components: {VirtualScroll, VirtualColumn},
        data: function () {
            return {
                virtItems: [], //虚拟列表（临时变量，无须处理，承载了视口部分的数据）
                transVoucherInfo: {
                    itemList: []
                },
                dstWarehouseName: null,
                dstWarehouseId: null,
                acctEnterWayMap: {},
                allotAcntTypeMap: getEnumMap("allotAcntType", "value2text"),
                assetTypeMap: getEnumMap("assetType", "value2text"),
                commonDevcVal: getEnumInfoWith('assetType', 'name', 'CommonDevc').value,
                //
                singleDevices: [],
                scopeEntity: null,
                fiscalTaxMarkList: [],
                srcNormalFlag: false,
                defaultTaxRate: 0,
                allotIntoDepartAllowed: true,
                //
                devcCustTag1: {
                    dispName: '自定义标签1',
                    itemList: [],
                    enabled: false,
                    refUsed: false
                },
                devcCustTag2: {
                    dispName: '自定义标签2',
                    itemList: [],
                    enabled: false,
                    refUsed: false
                },
                devcCustTag3: {
                    dispName: '自定义标签3',
                    itemList: [],
                    enabled: false,
                    refUsed: false
                }
            }
        },
        created: function () {
            let self = this;
            self.getCustTagMetaFields();

            getMerchantBizParam("asset.finac.enabled", function (result) {
                self.srcNormalFlag = Utils.isTrue(result);
            }, 2, self.srcComId);
            getMerchantBizParam("asset.trans.biz.default.tax.rate", function (result) {
                self.defaultTaxRate = result;
            });
            getMerchantBizParam('shop.asset.allot.into.depart.allowed', function (result) {  // 门店资产调拨是否允许调入到部门
                self.allotIntoDepartAllowed = Utils.isTrue(result);
            }, 0);
            this.acctEnterWayMap = getEnumMap("acctEnterWay", "value2text");
            if (!Utils.isNoB(this.id)) {
                this.getShopDeviceTransVoucher();
            }
            this.getCurrentUserInfo();
            this.getFiscalTaxMarkList();
        },
        watch: {
            suitFlag(newVal, oldVal){
                if (oldVal != newVal) {
                    this.transVoucherInfo.itemList = [];
                }
            },
            transItemList(newVal, oldVal){
                let self = this;
                if (newVal.length != oldVal.length) {
                    let offline = this.offline || false;
                    let itemList = this.transItemList || [];
                    for(let i = 0; i < itemList.length; i++) {
                        let item = itemList[i];
                        item.transAll = offline || !Utils.isTrue(item.splitFlag);

                        itemList[i] = self.splitFlagChange2(item);
                    }
                    this.transVoucherInfo.itemList = Utils.merge([], itemList);
                    this.$emit('getDevicesLength', itemList);
                }
            },
            reloadItemInfo(newVal, oldVal){
                if (oldVal != newVal) {
                    this.getShopDeviceTransVoucher();
                }
            }
        },
        methods: {
            viewAssetInfo: function (row) {
                let assetType = getEnumInfoWith('assetType', "name", "CommonDevc").value;
                let params = {
                    innerCode: row.innerCode,
                    assetType: assetType
                };
                assetFiscalInfoDlg(params);
            },
            getFiscalTaxMarkList: function () {
                let self = this;
                let postData = {};
                postData.disabled = false;
                postData.type = getEnumInfoWith('taxType', "name", "XXS").value;
                //
                let theLoad = MsgBox.loading();
                fiscalBizApi.getFiscalTaxMarkPageList(postData, function (result) {
                    theLoad.hide();
                    if (result.type === "info") {
                        let fiscalTaxMarkList = result.data || [];
                        if (fiscalTaxMarkList.length > 0) {
                            fiscalTaxMarkList.forEach(function (item) {
                                item.rate = parseFloat(item.rate).toFixed(2)
                            })
                        }
                        self.fiscalTaxMarkList = fiscalTaxMarkList;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getCurrentUserInfo: function () {
                let self = this;
                userApi.getUserInfoByContext({}, function (result, jqXhr) {
                    if (result.type == 'info') {
                        let data = result.data;
                        let scopeEntity = data.scopeEntity || {};
                        self.scopeEntity = scopeEntity;
                    } else {
                        self.$message.error(result.message);
                    }
                });
            },
            getShopDeviceTransVoucher: function () {
                let self = this;
                let postData = {};
                postData.id = self.id;
                assetVchrApi.getShopDeviceTransVoucherById(postData, function (result) {
                    if (result.type == "info") {
                        let itemList = result.data.itemList || [];
                        self.getDstWarehouseList(result.data.dstBizUnitId, function (wareList) {
                            itemList.forEach(function (item) {
                                item.dstWareHouseList = wareList;
                                //
                                let transQuantity = 0;
                                if (Utils.isTrue(item.assetType == 1)) {
                                    transQuantity = item.existQuanity - item.scrappedQuantity;
                                    if (transQuantity < 0) {
                                        transQuantity = 0;
                                    }
                                } else {
                                    transQuantity = 1;
                                }
                                item.transQuantity = transQuantity;
                                item.transAll = !Utils.isTrue(item.splitFlag);
                            });
                            self.transVoucherInfo.itemList = Utils.merge([], itemList);
                            self.transVoucherInfo.reserveFlag = result.data.reserveFlag;
                            self.transVoucherInfo = Utils.merge({}, self.transVoucherInfo);
                            self.$emit('getDevicesLength', itemList);
                        });
                        //
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            //
            selectDstBizUnitName(scopeIndex){
                let virtTable = this.$refs['virtTable'];
                let rowIndex = virtTable.start + scopeIndex;
                let self = this;
                let transVoucherInfo = self.transVoucherInfo;
                let itemList = transVoucherInfo.itemList || [];
                let deviceInfo = itemList[rowIndex];
                //
                let dlgConfig = {
                    merchantId: deviceInfo.dstMerchantId,
                    isRadio: true,
                    isCom: true,
                    enableSearch: true,
                    bizDepart: true,
                    title: '机构--选择',
                    showMerchtSelect: true,
                    optionalState: [1, 3],
                    defalultState: [1]
                };
                openRetailComTreeSelectDlg(dlgConfig, function (result) {
                    let allotIntoDepartAllowed = self.allotIntoDepartAllowed;
                    if(allotIntoDepartAllowed != true) {
                        let orgType = result.orgType;
                        let bizUnitShopFlag = result.bizUnitShopFlag;
                        if(orgType == 0 && bizUnitShopFlag == true) {
                            MsgBox.warning('禁止调入部门，请选择调入门店');
                            return false;
                        }
                    }
                    // 调拨业务不允许从开启财务的业务单元向未开启财务的业务单元发起
                    getMerchantBizParam("asset.finac.enabled", function (resultX) {
                        let dstNormalFlag = Utils.isTrue(resultX);
                        if (deviceInfo.fiscalAcctFlag && self.srcNormalFlag && !dstNormalFlag) {
                            MsgBox.warning('不允许从开启财务的业务单元向未开启财务的业务单元发起调拨资产');
                        } else {
                            deviceInfo.dstMerchantId = result.merchantId;
                            deviceInfo.dstMerchantName = result.merchantName;
                            deviceInfo.dstBizUnitId = result.bizUnitId;
                            deviceInfo.dstBizUnitName = result.bizUnitName;
                            deviceInfo.dstComId = result.id;
                            deviceInfo.dstComNo = result.no;
                            deviceInfo.dstComName = result.name;
                            deviceInfo.dstComFullName = result.fullName;
                            deviceInfo.dstRealComName = result.realComName;
                            deviceInfo.dstRealComCode = result.realComCode;
                            deviceInfo.dstCostCenterCode = result.costCenterCode;
                            //
                            self.getAllotAcntType(deviceInfo, function (allotAcntType) {
                                deviceInfo.allotAcntType = allotAcntType;
                                self.getDstWarehouseList(result.bizUnitId, function (dstWareHouseList) {
                                    //
                                    deviceInfo.dstWareHouseList = Utils.merge([], dstWareHouseList);
                                    let defWare = dstWareHouseList.find(function (ware) {
                                        return ware.defaulted == true;
                                    });
                                    deviceInfo.dstWarehouseId = defWare.id;
                                    deviceInfo.dstWarehouseName = defWare.name;
                                    // transVoucherInfo.itemList = Utils.merge([], itemList);
                                    // self.transVoucherInfo = Utils.merge({}, transVoucherInfo);
                                    self.$set(self.transVoucherInfo.itemList, rowIndex, deviceInfo);
                                    self.$emit('getDevicesLength', itemList);
                                });
                            });
                        }
                    }, 2, result.bizUnitId);
                });
            },
            getDstWarehouseList: function (retailerShopId, callbackFun) {
                let filterItems = {};
                filterItems.retailerShopId = retailerShopId;
                let postData = {
                    filterItems: filterItems
                };
                let theLoad = MsgBox.loading();
                shopStockApi.getShopWarehouseNotPageList(postData, function (result) {
                    theLoad.hide();
                    if (result.type == 'info') {
                        //
                        callbackFun(result.data);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            selectDstWarehouse(rowIndex){
                let self = this;
                let transVoucherInfo = self.transVoucherInfo;
                let itemList = transVoucherInfo.itemList;
                let deviceInfo = itemList[rowIndex];
                let dstWarehouseId = deviceInfo.dstWarehouseId;
                let dstWareHouseList = deviceInfo.dstWareHouseList;
                let wareHouse = dstWareHouseList.find(function (item) {
                    return item.id == dstWarehouseId;
                });
                deviceInfo.dstWarehouseName = wareHouse.name;
                self.transVoucherInfo = Utils.merge({}, transVoucherInfo);
            },
            getAllotAcntType: function (item, callBack) {
                let postData = {
                    dstComId: item.dstComId,
                    srcComId: item.srcComId
                };
                assetVchrApi.getShopDeviceTransVoucherAllotAcntType(postData, function (result) {
                    if (result.type === "info") {
                        //
                        callBack(result.data)
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 是否需要拆分
            splitFlagChange: function (index) {
                let virtTable = this.$refs['virtTable'];
                let rowIndex = virtTable.start + index;
                let items = this.transVoucherInfo.itemList || [];
                let item = items[rowIndex];
                items[rowIndex] = this.splitFlagChange2(item);
                this.transVoucherInfo.itemList = Utils.merge([], items);
                this.$emit('getDevicesLength', items);
            },
            splitFlagChange2: function(item) {
                if(Utils.isTrue(item.transAll)) {
                    item.splitFlag = false;
                    item.quantity = item.transQuantity;
                    //
                    let assetOrgWorth = item.assetOrgWorth || 0;
                    let fiscalQuantity = item.fiscalQuantity || 0;
                    // 现存数量
                    let existQuanity = item.existQuanity || 0;
                    if (Utils.isTrue(item.fiscalAcctFlag)) {
                        if (fiscalQuantity == 0) {
                            fiscalQuantity = 1;
                        }
                        if (item.quantity >= fiscalQuantity) {
                            item.splittedAmount = assetOrgWorth.toFixed(2);
                        } else {
                            item.splittedAmount = ((parseFloat(assetOrgWorth) / parseInt(fiscalQuantity)) * item.quantity).toFixed(2);
                        }
                    } else {
                        if (existQuanity == 0) {
                            existQuanity = 1;
                        }
                        if (item.quantity >= existQuanity) {
                            item.splittedAmount = assetOrgWorth.toFixed(2);
                        } else {
                            item.splittedAmount = ((parseFloat(assetOrgWorth) / parseInt(existQuanity)) * item.quantity).toFixed(2);
                        }
                    }
                } else {
                    item.splitFlag = true;
                }
                return item;
            },
            disabledQuantity: function (splitible, splitFlag) {
                if (splitible) {
                    return splitible;
                } else {
                    return this.taxRateChange || !splitFlag
                }
            },
            // 调拨数量校验
            inputTransAvQuantity: function (rule, value, callback) {
                if (Utils.isNoB(value) || value < 1) {
                    callback(new Error('数量不可小于1'));
                } else {
                    if (!Utils.isIntStr(value)) {
                        callback(new Error('数量不可为小数'));
                    } else {
                        callback();
                    }
                }
            },
            // 数量变化校验
            transAvQuantityChange: function (scope) {
                let items = this.transVoucherInfo.itemList || [];
                items.forEach(function (item) {
                    if (item.deviceXId == scope.row.deviceXId) {
                        // 调拨数量
                        let quantity = item.quantity;
                        if (Utils.isNoB(quantity)) {
                            item.quantity = 1;
                            item.quantity2 = 0;
                        } else {
                            // 现存数量
                            let existQuanity = item.existQuanity || 0;
                            // 可调拨数量
                            let transQuantity = item.transQuantity || 0;
                            // 报废数量
                            let scrappedQuantity = item.scrappedQuantity || 0;
                            if (transQuantity < quantity && !item.splitible) {
                                Toast.show("当前调拨数量" + quantity + "，大于可调拨数量：" + transQuantity, 2000, 'info');
                            } else {
                                // 现存未报废数量
                                let unScrappedQuantity = existQuanity - scrappedQuantity;
                                if (quantity > unScrappedQuantity) {
                                    // 含报废数量
                                    let quantity2 = quantity - unScrappedQuantity;
                                    if (quantity2 > scrappedQuantity) {
                                        quantity2 = scrappedQuantity;
                                    }
                                    item.quantity2 = quantity2;
                                } else {
                                    // 含报废数量
                                    item.quantity2 = 0;
                                }
                                // 数量变动计算调拨金额
                                let assetOrgWorth = item.assetOrgWorth || 0;
                                let fiscalQuantity = item.fiscalQuantity || 0;
                                if (Utils.isTrue(item.fiscalAcctFlag)) {
                                    if (fiscalQuantity == 0) {
                                        fiscalQuantity = 1;
                                    }
                                    if (quantity >= fiscalQuantity) {
                                        item.splittedAmount = assetOrgWorth.toFixed(2);
                                    } else {
                                        item.splittedAmount = ((parseFloat(assetOrgWorth) / parseInt(fiscalQuantity)) * quantity).toFixed(2);
                                    }
                                } else {
                                    if (existQuanity == 0) {
                                        existQuanity = 1;
                                    }
                                    if (quantity >= existQuanity) {
                                        item.splittedAmount = assetOrgWorth.toFixed(2);
                                    } else {
                                        item.splittedAmount = ((parseFloat(assetOrgWorth) / parseInt(existQuanity)) * quantity).toFixed(2);
                                    }
                                }
                            }
                        }
                    }
                });
                this.transVoucherInfo.itemList = Utils.merge([], items);
                this.$emit('getDevicesLength', items);
            },
            // 调拨金额校验
            inputSplittedAmount: function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback(new Error('不可为空!'));
                } else {
                    if (Utils.isMoneyStr(value) && parseFloat(value) >= 0) {
                        callback();
                    } else {
                        callback(new Error('必须为大于等于0的数字!'));
                    }
                }
            },
            splittedAmountChange: function (rows) {
                let item = rows.row || {};
                let splittedAmount = item.splittedAmount || 0;
                let assetOrgWorth = item.assetOrgWorth || 0;
                if (Utils.isNoB(this.id) && parseFloat(splittedAmount) > parseFloat(assetOrgWorth) && item.splitFlag) {
                    MsgBox.warning("调拨原值必须小于资产原值！");
                }
                if (Utils.isNoB(this.id) && parseFloat(splittedAmount) == parseFloat(assetOrgWorth) && item.splitFlag) {
                    item.transAll = true;
                }
                item.splittedAmount = parseFloat(splittedAmount).toFixed(2);
                //
                this.$emit('getDevicesLength', this.transVoucherInfo.itemList);
            },
            // 移除资产
            removeDeviceItem: function (index) {
                let virtTable = this.$refs['virtTable'];
                let theIndex = virtTable.start + index;
                let self = this;
                let itemList = self.transVoucherInfo.itemList || [];
                itemList.splice(theIndex, 1);
                if (itemList.length == 0) {
                    self.removeDeviceList();
                }
                self.transVoucherInfo.itemList = Utils.merge([], itemList);
                //
                this.$emit('getDevicesLength', itemList);
            },
            getItemIds(){
                let itemList = this.transVoucherInfo.itemList || [];
                return itemList.pluck('deviceXId');
            },
            // 对应数据的返回
            getResult: function () {
                let self = this;
                let result = {};
                //
                let itemList = self.transVoucherInfo.itemList || [];
                if (!Utils.isNoB(itemList) && itemList.length > 0) {
                    let validateFailureFlag = false;
                    for (let i = 0; i < itemList.length; i++) {
                        let deviceItem = itemList[i];
                        if (Utils.isNoB(deviceItem.dstComId)) {
                            validateFailureFlag = true;
                            result.type = 'warn';
                            result.message = "单品资产【" + deviceItem.title + "】调拨要选调入机构";
                            break;
                        }
                        if (deviceItem.transQuantity < deviceItem.quantity && !deviceItem.splitible) {
                            validateFailureFlag = true;
                            result.type = 'warn';
                            result.message = "当前调拨数量" + deviceItem.quantity + "，大于可调拨数量：" + deviceItem.transQuantity;
                            break;
                        }
                    }
                    if (!Utils.isTrue(validateFailureFlag)) {
                        //
                        let deviceValidResult = self.getRules();
                        let deviceValid = deviceValidResult.returnValue;
                        if (!deviceValid) {
                            result.type = 'warn';
                            result.message = '请输入资产中相应的数据！';
                        } else {
                            result.type = 'info';
                        }
                        result.data = itemList;
                    }
                }
                return result;
            },
            // 对于数据的校验
            getRules: function () {
                let result = {};
                let returnValue = false;
                this.$refs['deviceItem'].validate(function (valid) {
                    if (valid) {
                        returnValue = true;
                    }
                });
                result.returnValue = returnValue;
                return result;
            },
            //
            removeDeviceList: function () {
                this.$emit('sync-src-Warehouse-device', false);
            },
            selectDstMerchtName(index){
                let self = this;
                let transVoucherInfo = self.transVoucherInfo;
                let itemList = transVoucherInfo.itemList || [];
                let deviceInfo = itemList[index];
                //
                let params = {
                    isMultiple: false,
                    selectCheckComInfo: {
                        id: deviceInfo.dstMerchantId,
                        name: deviceInfo.dstMerchantName
                    }
                };
                openRetailerListForSelectDlg(params, function (resultData) {
                    deviceInfo.dstMerchantId = resultData.id;
                    deviceInfo.dstMerchantName = resultData.name;
                    deviceInfo.dstBizUnitId = null;
                    deviceInfo.dstBizUnitName = null;
                    deviceInfo.dstComId = null;
                    deviceInfo.dstComName = null;
                    deviceInfo.dstRealComName = null;
                    deviceInfo.dstRealComCode = null;
                    deviceInfo.dstCostCenterCode = null;
                    deviceInfo.dstWarehouseId = null;
                    deviceInfo.dstWarehouseName = null;
                    deviceInfo.dstWareHouseList = [];
                    //
                    transVoucherInfo.itemList = Utils.merge([], itemList);
                    self.transVoucherInfo = Utils.merge({}, transVoucherInfo);
                });
            },
            setDstInfo(result){
                let self = this;
                let itemList = this.transVoucherInfo.itemList || [];
                //
                self.getDstWarehouseList(result.bizUnitId, function (dstWareHouseList) {
                    //
                    let defWare = dstWareHouseList.find(function (ware) {
                        return ware.defaulted == true;
                    });
                    self.getAllotAcntType({
                        dstComId: result.id,
                        srcComId: itemList[0].srcComId
                    }, function (allotAcntType) {
                        for (let i = 0; i < itemList.length; i++) {
                            let model = itemList[i];
                            model.dstMerchantId = result.merchantId;
                            model.dstMerchantName = result.merchantName;
                            model.dstBizUnitId = result.bizUnitId;
                            model.dstBizUnitName = result.bizUnitName;
                            model.dstComId = result.id;
                            model.dstComNo = result.no;
                            model.dstComName = result.name;
                            model.dstComFullName = result.fullName;
                            model.dstRealComName = result.realComName;
                            model.dstRealComCode = result.realComCode;
                            model.dstCostCenterCode = result.costCenterCode;
                            model.dstWareHouseList = Utils.merge([], dstWareHouseList);
                            model.dstWarehouseId = defWare.id;
                            model.dstWarehouseName = defWare.name;
                            model.allotAcntType = allotAcntType;
                        }
                        self.transVoucherInfo.itemList = Utils.merge([], itemList);
                        self.transVoucherInfo = Utils.merge({}, self.transVoucherInfo);
                        self.$emit('getDevicesLength', itemList);
                    });
                });
            },
            rateChange(){
                this.$emit('getDevicesLength', this.transVoucherInfo.itemList);
            },
            memoChange(){
                this.$emit('getDevicesLength', this.transVoucherInfo.itemList);
            },
            getCustTagMetaFields: function () {
                let self = this
                let param = [{tagMetaTableName: 'shop_device', tagMetaRole: 1}]
                custTagMeataApi.getCustTagMetaFields(param, function (result) {
                    if (result.type == 'info') {
                        let tags = result.data
                        for(let i=0; i< tags.length; i++) {
                            let tag = tags[i]
                            if(tag.fieldName == 'devcCustTag1') {
                                self.devcCustTag1 = {
                                    dispName: tag.dispName,
                                    itemList: tag.itemList,
                                    enabled: tag.enabled,
                                    refUsed: tag.refUsed
                                }
                            } else if(tag.fieldName == 'devcCustTag2') {
                                self.devcCustTag2 = {
                                    dispName: tag.dispName,
                                    itemList: tag.itemList,
                                    enabled: tag.enabled,
                                    refUsed: tag.refUsed
                                }
                            } else if(tag.fieldName == 'devcCustTag3') {
                                self.devcCustTag3 = {
                                    dispName: tag.dispName,
                                    itemList: tag.itemList,
                                    enabled: tag.enabled,
                                    refUsed: tag.refUsed
                                }
                            }
                        }
                    } else {
                        MsgBox.warning(result.message)
                    }
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/transVoucher/ShopDeviceTransVoucherDeviceScroll.vue